import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const clearStateDetailBagSize = createAction(ACTION.CLEAR_STATE_DETAIL_BAG_SIZE);
export const fetchDetailBagSize = createAction(ACTION.FETCH_DETAIL_BAG_SIZE.REQUEST, id => ({id}));
export const updateBagSize = createAction(ACTION.UPDATE_BAG_SIZE.REQUEST, (id, data) => ({id, data}));
export const fetchBagSizes = createAction(ACTION.FETCH_BAG_SIZE.REQUEST, params => ({params}));
export const fetchSuggestBagSize = createAction(ACTION.FETCH_BAG_SIZE_SUGGEST.REQUEST, params => ({params}));
